export const monthOptions = JSON.parse(process.env.REACT_APP_MONTH_OPTIONS);